export const T = {
  en_GB: {
    year: "Year",
    fullYear: "Full year",
    quarter: (q: number) => `Q${q}`,
  },
  nb_NO: {
    year: "År",
    fullYear: "Hele året",
    quarter: (q: number) => `K${q}`,
  },
} as const;
